<div class="dialog-header">
  <h6 matDialogTitle>Add Node</h6>
  <button
    class="close-button"
    bciprimarybutton
    tabindex="-1"
    (click)="close(false)"
  >
    <i class="Bosch-Ic Bosch-Ic-abort" aria-hidden="true"></i>
  </button>
</div>
<mat-divider></mat-divider>
<mat-dialog-content>
  <form [formGroup]="formData" #formDirective="ngForm" novalidate>
    <div class="row node-form">
      <div class="col-md-1">
        <mat-radio-button
          class="label-input"
          [ngModelOptions]="{ standalone: true }"
          [(ngModel)]="modalForm.nodeType"
          (ngModelChange)="changeNodeType()"
          name="nodeType"
          value="TEXT"
        ></mat-radio-button>
      </div>
      <div class="col-md-4">
        <mat-label class="label-input" id="label-input-node"
          >Node Name</mat-label
        >
      </div>
      <div class="col-md-7">
        <mat-form-field>
          <input
            type="text"
            matInput
            formControlName="nodeTitleCtr"
            [(ngModel)]="modalForm.nodeName"
            name="NodeName"
            [disabled]="modalForm.nodeType !== nodeType.TEXT"
          />
          <mat-error *ngIf="isFieldHasError('nodeTitleCtr', 'required')"
            >NodeName required.</mat-error
          >
          <mat-error *ngIf="isFieldHasError('nodeTitleCtr', 'minlength')"
            >NodeName is too short (min 2 Characters).</mat-error
          >
          <mat-error *ngIf="isFieldHasError('nodeTitleCtr', 'maxlength')"
            >NodeName is too long (max 30 Characters).</mat-error
          >
        </mat-form-field>
      </div>
    </div>
    <div class="row node-form-selected">
      <div class="col-md-1">
        <mat-radio-button
          class="label-input"
          [ngModelOptions]="{ standalone: true }"
          [(ngModel)]="modalForm.nodeType"
          (ngModelChange)="changeNodeType()"
          name="nodeType"
          value="PROCESS"
        >
        </mat-radio-button>
      </div>
      <div class="col-md-4" id="label-loads">Assign Process And Loads</div>
      <div class="col-md-7">
        <mat-form-field>
          <mat-label>Select Process</mat-label>
          <mat-select
            [(ngModel)]="modalForm.selectedProcess"
            formControlName="selectedProcessCtr"
          >
            <mat-option *ngFor="let item of processes" [value]="item">{{
              item.name
            }}</mat-option>
          </mat-select>
          <mat-error *ngIf="isFieldHasError('selectedProcessCtr', 'required')"
            >Please Select Process</mat-error
          >
        </mat-form-field>
      </div>
    </div>
    <div class="row node-form-selected">
      <div class="col-md-1">
        <mat-radio-button
          class="label-input"
          [ngModelOptions]="{ standalone: true }"
          [(ngModel)]="modalForm.nodeType"
          (ngModelChange)="changeNodeType()"
          name="nodeType"
          value="VIRTUAL_GROUP"
        >
        </mat-radio-button>
      </div>
      <div class="col-md-4" id="label-virtual-group">Assign Virtual Group</div>
      <div class="col-md-7">
        <mat-form-field>
          <mat-label>Select Virtual Group</mat-label>
          <mat-select
            [(ngModel)]="modalForm.selectedVirtualGroup"
            formControlName="selectedVirtualGroupCtr"
          >
            <mat-option
              *ngFor="let item of virtualGroupsConfiguredForSite"
              [value]="item"
              >{{ item }}</mat-option
            >
          </mat-select>
          <mat-error
            *ngIf="isFieldHasError('selectedVirtualGroupCtr', 'required')"
            >Please Select Virtual Group</mat-error
          >
        </mat-form-field>
      </div>
    </div>
    <div
      class="row node-form-selected"
      *ngIf="modalForm.nodeType !== nodeType.VIRTUAL_GROUP"
    >
      <div class="col-md-1">
        <mat-checkbox
          [(ngModel)]="modalForm.hasAttachment"
          [ngModelOptions]="{ standalone: true }"
        ></mat-checkbox>
      </div>
      <div class="col-md-4" id="label-attachement">Has Attachment</div>
    </div>
    <mat-divider></mat-divider>
    <div class="row" style="text-align: center">
      <button
        type="button"
        class="button-primary alignClose"
        id="save-node"
        bciprimarybutton
        (click)="saveNode()"
        [disabled]="formData.invalid"
      >
        OK
      </button>
      <button
        type="button"
        class="button-primary alignClose"
        id="close-node"
        bciprimarybutton
        (click)="close(false)"
      >
        Close
      </button>
    </div>
  </form>
</mat-dialog-content>
